import type { Observer } from '@naturehouse/nh-essentials/lib/architecture/ObserverPattern';
import type AbstractSubject from '@naturehouse/nh-essentials/lib/architecture/ObserverPattern';
import ArrivalDepartureFilter from '../store/ArrivalDepartureFilter';
import HouseSearchFilters from '../store/HouseSearchFilters';
import PriceFilter from '../store/PriceFilter';

export default class ArrivalDepartureToPriceConnector implements Observer {
    readonly #priceFilter: PriceFilter;

    constructor(priceFilter: PriceFilter) {
        this.#priceFilter = priceFilter;
    }

    public update(subject: AbstractSubject): void {
        if (!(subject instanceof ArrivalDepartureFilter)) {
            return;
        }

        if (!subject.parameters.arrivalDate || !subject.parameters.departureDate) {
            this.#priceFilter.enabled = false;
            return;
        }

        this.#priceFilter.enabled = subject.enabled;
    }

    public static connect(): void {
        const filters = HouseSearchFilters.getInstance();
        const priceFilter = filters.get(PriceFilter.NAME) as PriceFilter | undefined;
        const arrivalDepartureFilter = filters.get(ArrivalDepartureFilter.NAME) as
            | ArrivalDepartureFilter
            | undefined;

        if (!arrivalDepartureFilter || !priceFilter) return;

        const connector = new ArrivalDepartureToPriceConnector(priceFilter);
        arrivalDepartureFilter.attach(connector);
    }
}
